import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, inject, PLATFORM_ID } from '@angular/core';

@Component({
    selector: 'app-ai',
    templateUrl: './ai.component.html',
    styleUrls: ['./ai.component.scss'],
    standalone: false,
})
export class AiComponent implements AfterViewInit {
    private readonly _platformId = inject(PLATFORM_ID);
    private readonly cdRef = inject(ChangeDetectorRef);

    ngAfterViewInit(): void {
        // Force change detection after view init — needed for SSR hydration
        if (isPlatformBrowser(this._platformId)) {
            this.cdRef.detectChanges();
        }
    }
}
